// @flow
import * as React from "react";
import styled from "styled-components";
import { connect, type MapStateToProps } from "react-redux";
import posed, { PoseGroup } from "react-pose";
import { Link } from "../common/Link";
import Gettext from "../common/Gettext";
import { gaReducer } from "../GA";
import { fontSize } from "../common/styled-mixins";
import { InfoTour } from "../Icons/Info";
import { TourContext } from "../Tour";

import type { Profile } from "../../redux/CommonTypes";
import type { State as ReduxState } from "../../redux/reducer";

const duration = 200; // in ms

const InfoTourIcon = styled(InfoTour)`
  position: relative;
  flex-grow: 0;
  flex-shrink: 0;
  background-color: ${({ theme }) => theme.background};
  background-clip: padding-box;
  border-top-left-radius: 50%;
  border-top-right-radius: 50%;
  border-bottom-right-radius: 50%;
  transition: inherit;
  z-index: 2;
`;

const Hint = styled(Link)`
  position: absolute;
  top: 100px;
  left: 0;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  align-content: flex-start;
  justify-content: flex-start;
  height: 30px;
  padding-left: 25px;
  text-decoration: none;
  transition: all ${duration}ms ease-in-out;
  opacity: 0.6;

  ${InfoTourIcon} {
    color: #919191;
  }

  :hover {
    opacity: 1;

    ${InfoTourIcon} {
      color: ${({ theme }) => theme.upper};
    }
  }
`;

const _Content = styled.div`
  position: relative;
  flex-grow: 1;
  flex-shrink: 0;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  align-content: center;
  height: 100%;
  margin-left: -4px;
  padding-left: 4px;
  box-sizing: border-box;
  transform-origin: left bottom;
  overflow: hidden;
  z-index: 1;
`;

const Scoop = styled.i`
  position: relative;
  margin-left: -13px;
  flex-grow: 0;
  flex-shrink: 0;
  height: 100%;
  width: 17px;
  overflow: hidden;

  :before {
    content: "";
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    width: 34px;
    height: 34px;
    border-radius: 50%;
    box-shadow: 0px 0px 0px 50px
      ${({ theme }) =>
        theme.mode === "light" ? "#fff" : "rgba(255, 255, 255, 0.1)"};
  }
`;

const Text = styled.div`
  flex-grow: 1;
  flex-shrink: 0;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  align-content: center;
  height: 100%;
  padding-left: 4px;
  padding-right: 10px;
  font-size: ${fontSize(12)};
  white-space: nowrap;
  color: ${({ theme }) => theme.accent};
  background-color: ${({ theme }) =>
    theme.mode === "light" ? "#fff" : "rgba(255, 255, 255, 0.1)"};
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
`;

const Content = posed(_Content)({
  enter: {
    x: 0,
    scaleX: 1,
    transition: {
      duration,
      ease: "easeInOut"
    }
  },
  exit: {
    x: -17,
    scaleX: 0,
    originX: 0,
    originY: "50%",
    transition: {
      duration,
      ease: "easeInOut"
    }
  }
});

type Props = {
  profile: Profile
};

const TourHint = (props: Props) => {
  const [visible, setVisibitily] = React.useState(false);
  const { session_count } = props.profile;
  const tour = React.useContext(TourContext);

  if (session_count > 3 || tour != null) {
    return null;
  }

  return (
    <Hint
      to="/sightseeing"
      onMouseEnter={() => setVisibitily(true)}
      onMouseLeave={() => setVisibitily(false)}
      onClick={() => gaReducer("ACTIVATE_TOUR_FROM_ICON")}
    >
      <InfoTourIcon />
      <PoseGroup>
        {visible && (
          <Content key="content">
            <Scoop />
            <Text>
              <Gettext>Start Welcome Tour</Gettext>
            </Text>
          </Content>
        )}
      </PoseGroup>
    </Hint>
  );
};

const mapStateToProps = (state: ReduxState) => ({
  profile: state.profile
});

export default connect((mapStateToProps: MapStateToProps<*, *, *>))(TourHint);



// WEBPACK FOOTER //
// ./src/components/Chart/TourHint.js